
import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { NgbdSortableHeader, SortEvent } from 'src/app/_directives/sortable.directive';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { Router } from '@angular/router';
import { ToastService } from 'src/app/_services/toastservice';
import { ToastrService } from 'ngx-toastr';
import { City } from 'src/app/_models/City';
import { CityService } from 'src/app/_services/city.service';

@Component({
  selector: 'app-city',
  templateUrl: './city.component.html',
  providers: []
})
export class CityComponent implements OnInit {
  data$: Observable<City[]>;
  oldData: City[];
  total$: Observable<number>;
  loading$: Observable<boolean>;
  private selectedBrand;
  locationSubscription: Subscription;
  submit: boolean;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  constructor(public service: CityService,
    public ls: LocalStorageService,
    public ts: ToastService,
    public tss: ToastrService,
    public router: Router) {

    this.selectedBrand = this.ls.getSelectedUser().userID;
    this.loading$ = service.loading$;
    this.submit = false;
  }

  ngOnInit() {
    this.getData();
  }

  getData() {
    this.service.getAllData();
    this.data$ = this.service.data$;
    this.total$ = this.service.total$;
    this.loading$ = this.service.loading$;
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.service.sortColumn = column;
    this.service.sortDirection = direction;
  }

  Edit(city) {
    this.router.navigate(["admin/city/edit", city]);
  }

  Delete(obj) {
    if (confirm("Are you sure to delete? ")) {
      this.service.delete(obj).subscribe((res: any) => {
        if (res != 0) {
          this.ts.showSuccess("Success", "Record deleted successfully.")
          this.getData();
        }
        else {
          this.ts.showError("Error", "Failed to delete record.");
        }
      }, error => {
        this.ts.showError("Error", "Failed to delete record.")
      });
    }
  }
}
